<template>
  <div class="component-form">
    <h1 class="form-title">Syllabus Draft</h1>
    <p class="text mt-30">
      A template (below) has been provided for your convenience when formatting your seminar outline. Please create a copy of the document and replace all the
      highlighted fields with relevant information pertaining to your seminar. When finished, please submit a sharing link (with editing enabled) to the SL
      Portal.
    </p>
    <Button class="btn-download mt-20" skin="grey" @click="handleClickDownload">Syllabus Template</Button>
    <p class="text mt-20">
      With the syllabus draft, we’ll need to collect your seminar description and required/optional readings. Please fill out the form below.
    </p>
    <div class="inp-wrap mt-20 large">
      <Input label="Official Seminar Title" :value="value.title" @input="handleInput($event, 'title')" />
    </div>
    <div class="inp-wrap mt-20 large">
      <Textarea :counter="false" placeholder="Official Seminar Description" :value="value.description" @input="handleInput($event, 'description')" />
    </div>
    <p class="text bold big mt-30">Seminar Track <span class="weak">Choose all that applies</span></p>
    <CheckboxGroup class="mt-10 checkboxgroup-wrap inp-wrap large" :options="GROUP_OPTIONS" :value="value.track" @input="handleInput($event, 'track')" />
    <p class="text bold mt-30 big">Upload merged reading PDF</p>
    <FileUploader
      class="mt-20 inp-wrap big"
      text="Upload"
      :acceptType="['PDF']"
      :value="value.pdf"
      @input="handleInput($event, 'pdf')"
      loadText="loading"
      :role="ROLES.SL"
    />
    <p class="text bold big mt-30">Please paste your syllabus sharing link here and click submit</p>
    <div class="inp-wrap mt-20 large">
      <Textarea :counter="false" placeholder="" :value="value.link" @input="handleInput($event, 'link')" />
    </div>
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import ROLES from '../../../../utils/roles';
import { Button, Input, FileUploader } from '../../../../components/form';
import CheckboxGroup from '../../../../components/form/CheckboxGroup/Prototype';
import Textarea from '../../../../components/form/Textarea/Prototype';
const GROUP_OPTIONS = [
  {
    value: 'Natural Sciences',
    label: 'Natural Sciences'
  },
  {
    value: 'Social Sciences',
    label: 'Social Sciences'
  },
  {
    value: 'Arts and Humanities',
    label: 'Arts and Humanities'
  },
  {
    value: 'Business Management and Finance',
    label: 'Business Management and Finance'
  }
];
export default {
  name: 'SyllabusDraft',
  components: {
    Button,
    Input,
    Textarea,
    CheckboxGroup,
    FileUploader
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    GROUP_OPTIONS() {
      return GROUP_OPTIONS;
    },
    ROLES() {
      return ROLES;
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    },
    handleClickDownload: function() {
      this.$windowOpen('https://docs.google.com/document/d/1On9g-Ifh5Ni3S-kq0Sumk-_NHYZOnNSb3xT64s09bwc/edit?usp=sharing');
    }
  }
};
</script>
